module.exports = __webpack_public_path__ + "catalog/footer/img/domaine-forget.png?hash=b52ba4b65d57c3945af00f51d103ed86";


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/asset-loader!./LeLab.DomaineForget.Web/src/modules/catalog/footer/img/domaine-forget.png
// module id = 165
// module chunks = 0